// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgTeleworkUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_4564_301560)">
					<path d="M13.94 15.9199H10.24V19.2399H13.94V15.9199Z" fill="#45BF34" />
					<path d="M17.52 8.89006L15.27 7.41006V5.56006H17.52V8.89006Z" fill="#45BF34" />
					<path
						d="M4.53008 10.87C4.35008 10.87 4.18008 10.78 4.08008 10.62C3.93008 10.37 4.00008 10.04 4.25008 9.89L12.1801 5L19.9401 9.89C20.1901 10.05 20.2601 10.38 20.1101 10.62C19.9501 10.87 19.6201 10.94 19.3801 10.79L12.1701 6.25L4.81008 10.8C4.72008 10.85 4.63008 10.88 4.53008 10.88V10.87Z"
						fill="black"
					/>
					<path
						d="M18.97 20.1401H5.21997V9.86008C5.21997 9.57008 5.45997 9.33008 5.74997 9.33008C6.03997 9.33008 6.27997 9.57008 6.27997 9.86008V19.0801H17.9V9.86008C17.9 9.57008 18.14 9.33008 18.43 9.33008C18.72 9.33008 18.96 9.57008 18.96 9.86008V20.1501L18.97 20.1401Z"
						fill="black"
					/>
					<path
						d="M19.5099 20.1401H4.66989C4.37989 20.1401 4.13989 19.9001 4.13989 19.6101C4.13989 19.3201 4.37989 19.0801 4.66989 19.0801H19.5099C19.7999 19.0801 20.0399 19.3201 20.0399 19.6101C20.0399 19.9001 19.7999 20.1401 19.5099 20.1401Z"
						fill="black"
					/>
					<path
						d="M15.0099 13.92H9.17993V9.98999H15.0099V13.92ZM10.2399 12.86H13.9399V11.06H10.2399V12.86Z"
						fill="black"
					/>
					<path
						d="M14.5299 20.14H9.6499V15.24H14.5299V20.14ZM10.7199 19.08H13.4699V16.3H10.7199V19.08Z"
						fill="black"
					/>
					<path
						d="M12.0901 13.51C11.8001 13.51 11.5601 13.27 11.5601 12.98V10.78C11.5601 10.49 11.8001 10.25 12.0901 10.25C12.3801 10.25 12.6201 10.49 12.6201 10.78V12.98C12.6201 13.27 12.3801 13.51 12.0901 13.51Z"
						fill="black"
					/>
					<path
						d="M17.5701 9.3501C17.2801 9.3501 17.0401 9.1101 17.0401 8.8201V6.1601H15.6701V7.2201C15.6701 7.5101 15.4301 7.7501 15.1401 7.7501C14.8501 7.7501 14.6101 7.5101 14.6101 7.2201V5.1001H18.1101V8.8301C18.1101 9.1201 17.8701 9.3601 17.5801 9.3601L17.5701 9.3501Z"
						fill="black"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4564_301560">
						<rect width={16.19} height={15.14} fill="white" transform="translate(4 5)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgTeleworkUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgTeleworkUnique24;
